import axios from "axios";
import io from "socket.io-client";
// import _ from 'lodash';

import config from "../../config";
import http from "../api/http";
import { authActions } from "../slices/auth-slice";
import { setAppNotification } from "./app-actions";
import { socketAuth } from "../api/socketAuth";

const socket = io(process.env.REACT_APP_API_URL, { auth: socketAuth });

// Function to create login session
async function createLoginSession(loggedInUserId) {
  try {
    // Get device info
    const userAgent = window.navigator.userAgent;
    var deviceInfo = userAgent;
    var location = "";

    // Get location
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        location = `Latitude: ${latitude}, Longitude: ${longitude}`;
      },
      (error) => {
        console.error("Error getting location:", error);
      }
    );

    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/createLoginSession`, {
      userId: loggedInUserId,
      connectionId: socket.id,
      ipAddress: "",
      deviceInfo: deviceInfo,
      location: location,
    });

    if (response.status === 200) {
      socket.emit("login", loggedInUserId, socket.id);
    } else {
      throw new Error("Failed to create login session");
    }
  } catch (error) {
    console.error("Error creating login session:", error);
  }
}

export const authLogin = (email, password, remembered) => {
  const apiBaseUrl =
    process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_SIGN_IN_URI;

  const objRequest = {
    email,
    password,
  };

  const request = axios.post(apiBaseUrl, objRequest);

  return (dispatch) => {
    dispatch(authActions.setLoading({ isLoading: true, willClearError: true }));

    return request.then(
      ({ data }) => {
        const userLoginData = data;
        localStorage.setItem("usersession", JSON.stringify(userLoginData));
        dispatch(authGetCurrentUser(userLoginData));
        localStorage.removeItem('session-expired');
        
        if (remembered) {
          // Remember-me stores the EMAIL only. The password is deliberately
          // never persisted: the previous AES-at-rest wrapper used a hardcoded
          // all-zero key, so it was obfuscation, not encryption.
          localStorage.setItem("username", email);
          localStorage.setItem("remembered", remembered);
        } else {
          localStorage.removeItem("username");
          localStorage.removeItem("password");
          localStorage.removeItem("remembered");
        }

        createLoginSession(userLoginData?.userId);
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === "string") {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === "string"
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === "string"
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          if (error.response) {
            errorMessage = "Login failed!";
          }
        }
        dispatch(setAppNotification("Error: " + errorMessage));
        localStorage.removeItem("usersession");
        dispatch(authActions.setError(errorMessage));
      }
    );
  };
};

export const authGetCurrentUser = (userLoginData) => {
  const apiBaseUrl =
    config.REACT_APP_API_BASE_URL +
    config.REACT_APP_API_USERS_URI +
    "/" +
    userLoginData.userId;

  const request = http.get(apiBaseUrl);

  return (dispatch) => {
    return request.then(
      ({ data }) => {
        let userInfoData = data?.user;

        localStorage.setItem("userinfo", JSON.stringify(userInfoData));
        dispatch(
          authActions.login({
            userLoginData,
            userInfoData,
          })
        );
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === "string") {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === "string"
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === "string"
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          if (error.response) {
            errorMessage = "Login failed!";
          }
        }
        dispatch(setAppNotification("Error: " + errorMessage));
        dispatch(authActions.setError("Login failed!"));
      }
    );
  };
};

export const signUpUser = ({
  firstName,
  lastName,
  email,
  password,
  phoneNumber,
  role,
}) => {
  const apiBaseUrl =
    config.REACT_APP_API_BASE_URL + config.REACT_APP_API_SIGN_REGISTER_URI;

  const payload = {
    firstName,
    lastName,
    email,
    password,
    phoneNumber,
    role,
    registrationType: "SignUp",
  };

  const request = axios.post(apiBaseUrl, payload);

  return (dispatch) => {
    dispatch(authActions.setLoading({ isLoading: true, willClearError: true }));
    return request.then(
      ({ data }) => {
        dispatch(
          setAppNotification(
            "Registration Success, We have sent an email to you. Please verify to activate your account.",
            "success"
          )
        );
        dispatch(
          authActions.setLoading({ isLoading: false, willClearError: true })
        );
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === "string") {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === "string"
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === "string"
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          if (error.response) {
            errorMessage = "Login failed!";
          }
        }

        dispatch(authActions.setError("Login failed!"));
        dispatch(setAppNotification("Error: " + errorMessage));
      }
    );
  };
};

export const requestForgotPassword = (email) => {
  const apiBaseUrl =
    config.REACT_APP_API_BASE_URL +
    config.REACT_APP_API_FORGET_PASSWORD_REQUEST_URI +
    "/" +
    email;

  const request = axios.post(apiBaseUrl);

  return (dispatch) => {
    dispatch(authActions.setLoading({ isLoading: true, willClearError: true }));
    return request.then(
      ({ data }) => {
        dispatch(
          setAppNotification(
            "Forget password link sent!  Please check your email.",
            "success"
          )
        );
        dispatch(
          authActions.setLoading({ isLoading: false, willClearError: true })
        );
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === "string") {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === "string"
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === "string"
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          // console.log("error.response: ", error.response);
          // console.log("error.request: ", error.request);
          // console.log("error.config: ", error.config);
          if (error.response) {
            errorMessage = "Login failed!";
          }
        }

        dispatch(authActions.setError("Login failed!"));
        dispatch(setAppNotification("Error: " + errorMessage));
      }
    );
  };
};

export const confirmForgetPassword = ({ token, userId, password }) => {
  const apiBaseUrl =
    config.REACT_APP_API_BASE_URL +
    config.REACT_APP_API_CONFIRM_RESET_PASSWORD_URI;

  const payload = { token, userId, password };

  const request = axios.post(apiBaseUrl, payload);

  return (dispatch) => {
    dispatch(authActions.setLoading({ isLoading: true, willClearError: true }));
    return request.then(
      ({ data }) => {
        dispatch(
          setAppNotification(
            "Change password now successful.  Please login with your new password.",
            "success"
          )
        );
        dispatch(
          authActions.setLoading({ isLoading: false, willClearError: true })
        );
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === "string") {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === "string"
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === "string"
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          if (error.response) {
            errorMessage = "Login failed!";
          }
        }

        dispatch(authActions.setError("Login failed!"));
        dispatch(setAppNotification("Error: " + errorMessage));
      }
    );
  };
};

export const verifyUser = (verifyCode, callBack) => {
  const apiBaseUrl =
    config.REACT_APP_API_BASE_URL +
    "/" +
    config.REACT_APP_APIT_USER_VERIFY +
    "/" +
    verifyCode;

  const request = axios.post(apiBaseUrl);

  return (dispatch) => {
    dispatch(authActions.setLoading({ isLoading: true, willClearError: true }));
    return request.then(
      ({ data }) => {
        dispatch(setAppNotification("Verify User Success!", "success"));
        dispatch(
          authActions.setLoading({ isLoading: false, willClearError: true })
        );
        if (typeof callBack === "function") {
          callBack();
        }
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === "string") {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === "string"
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === "string"
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          if (error.response) {
            errorMessage = "Login failed!";
          }
        }

        dispatch(authActions.setError("Login failed!"));
        dispatch(setAppNotification("Error: " + errorMessage));
      }
    );
  };
};

export const authClearRecaptchaTokenValidated = () => {
  return (dispatch) => {
    dispatch(authActions.clearRecaptchaTokenValidated());
  };
};

export const fetchUpdatedUserProfile = () => {
  let objAuthSession = JSON.parse(localStorage.getItem("usersession"));

  return (dispatch) => {
    dispatch(authGetCurrentUser(objAuthSession));
  };
};

export const authClearResetPasswordSent = () => {
  return (dispatch) => {
    dispatch(authActions.clearResetPasswordSent());
  };
};

export const authClearChangePasswordDone = () => {
  return (dispatch) => {
    dispatch(authActions.clearChangePasswordDone());
  };
};

export const authSetError = (errorMessage) => {
  return (dispatch) => {
    dispatch(authActions.setError(errorMessage));
  };
};

export const authClearError = () => {
  return (dispatch) => {
    dispatch(authActions.logout());
  };
};

export const authLogout = () => {
  localStorage.removeItem("userinfo");
  localStorage.removeItem("usersession");
  localStorage.removeItem("viewUserWithHeirarchy");
  // localStorage.clear();
  window.location.href = "/";
  return (dispatch) => {
    dispatch(authActions.logout());
  };
};
